module.exports = __webpack_public_path__ + "media/components/Marketing/Legal/sla_uptime_percent-c7ea4688cb21176043ce79ed2e95fb18.png";